import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import { UPDATE_BOT } from "../../../../graphql/mutations/management";
import { GET_BOT_LIST } from "../../../../graphql/queries/management";
import {
  clearBotForm,
  onChangeBotForm,
  toggleBotModal,
  uploadBotProfileImage,
} from "../../redux/botSlice";
import UploadBotProfileImage from "./UploadBotProfileImage";

const BotForm = () => {
  const dispatch = useDispatch();
  const { updateForm, file, uploadLoading } = useSelector((state) => state.bot);

  const [updateBot, { loading }] = useMutation(UPDATE_BOT, {
    refetchQueries: [{ query: GET_BOT_LIST }],
    onCompleted: (data) => {
      if (data) {
        toast.success(`ປັບປຸງຂໍ້ມູນສຳເລັດແລ້ວ`, {
          position: "top-center",
          className: "lao",
        });
        dispatch(clearBotForm());
        dispatch(toggleBotModal());
      }
    },
    onError(err) {
      toast.error(`ປັບປຸງຂໍ້ມູນສຳເລັດບໍສຳເລັດ ກາລຸນາລອງໃໝ່ ${err.message}`, {
        position: "top-center",
        className: "lao",
      });
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (file) {
      const { payload } = await dispatch(uploadBotProfileImage());
      if (payload?.success) {
        updateBot({
          variables: {
            id: updateForm.id,
            input: {
              nickname: updateForm.nickname,
              profileImage: payload.url,
            },
          },
        });
      } else {
        toast.error(`ບໍສາມາດອັບໂຫຼດຮູບໄດ້, ກາລຸນາລອງໃໝ່`, {
          position: "top-center",
          className: "lao",
        });
      }
    } else {
      updateBot({
        variables: {
          id: updateForm.id,
          input: {
            nickname: updateForm.nickname,
          },
        },
      });
    }
  };

  const handleChange = (e) =>
    dispatch(
      onChangeBotForm({ ...updateForm, [e.target.name]: e.target.value }),
    );

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ຊື່ຫຼິ້ນ"
        name="nickname"
        onChange={handleChange}
        type="text"
        value={updateForm.nickname}
        placeholder="ຊື່ປະເທດ"
        errorParam="nickname"
        required={true}
      />
      <UploadBotProfileImage />
      <div className="text-center">
        <SubmitButton loading={uploadLoading || loading} />
      </div>
    </Form>
  );
};

export default BotForm;
